var _rect, _rect2, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccessIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 48,
    height: 48,
    rx: 24,
    fill: "#CEFFEB"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 48,
    height: 48,
    rx: 24,
    stroke: "#E4FFF4",
    strokeWidth: 8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 38.75C22.07 38.75 17.25 33.93 17.25 28C17.25 22.07 22.07 17.25 28 17.25C33.93 17.25 38.75 22.07 38.75 28C38.75 33.93 33.93 38.75 28 38.75ZM28 18.75C22.9 18.75 18.75 22.9 18.75 28C18.75 33.1 22.9 37.25 28 37.25C33.1 37.25 37.25 33.1 37.25 28C37.25 22.9 33.1 18.75 28 18.75Z",
    fill: "#0FD99C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5804 31.5801C26.3804 31.5801 26.1904 31.5001 26.0504 31.3601L23.2204 28.5301C22.9304 28.2401 22.9304 27.7601 23.2204 27.4701C23.5104 27.1801 23.9904 27.1801 24.2804 27.4701L26.5804 29.7701L31.7204 24.6301C32.0104 24.3401 32.4904 24.3401 32.7804 24.6301C33.0704 24.9201 33.0704 25.4001 32.7804 25.6901L27.1104 31.3601C26.9704 31.5001 26.7804 31.5801 26.5804 31.5801Z",
    fill: "#0FD99C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessIcon);
export default __webpack_public_path__ + "static/media/success-icon.2497cdf0bea99f54be9d52f01bd7fe28.svg";
export { ForwardRef as ReactComponent };